import __ from "../admin-utils/LanguageHelper"

const baseDomain = 'https://api.baeynh.com'
const baseUrl = baseDomain + '/v1'
const authables = []
const currency = __('ريال', 'SAR')


export {
  baseUrl,
  baseDomain,
  authables,
  currency,

}
